import { ILastComment, getLastComment } from "api/postListApi";
import { isProfilePageState, isThroughMainState } from "recoil/contentsAtom";
import { useQuery } from "react-query";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import parse from "html-react-parser";
import md5 from "md5";
import CommentsLoading from "components/common/loading/CommentsLoading";
import { headersState } from "recoil/userInfoAtom";

interface IProps {
  sectionTItle: string;
  service_code: string;
  idx: number;
  isSuccess: boolean;
}

function LastComment(props: IProps) {
  const isProfilePage = useRecoilValue(isProfilePageState);
  const { profilekey } = useParams();
  const setIsThroughMain = useSetRecoilState(isThroughMainState);
  const navigate = useNavigate();

  const headers = useRecoilValue(headersState);

  const { isLoading, data } = useQuery<ILastComment>(
    ["last_comment", props.idx, props.isSuccess],
    () => getLastComment(headers, props.idx, isProfilePage),
    {
      refetchOnWindowFocus: false,
      notifyOnChangeProps: "tracked"
    }
  );

  const checkPostState = () => {
    setIsThroughMain(true);
  };

  const onClickNickname = (userProfilekey: string) => {
    navigate(`/profile/${userProfilekey}/post`);
  };

  return !isLoading ? (
    data?.result === 1 ? (
      <>
        <div className="reply feed">
          <div className="info clearfix">
            <img
              className="user-pic"
              src={
                data.data.admin_flag === 1
                  ? data.data.admin_icon
                  : data.data.profile_image_url_from === "" ||
                    data.data.profile_image_url_from === null
                    ? "https://file.valofe.com/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
                    : data.data.profile_image_url_from
              }
              alt="profile-default"
            />
            <span
              className="nickname"
              onClick={() => onClickNickname(data.data.user_profile_key)}
            >
              {data.data.user_nickname}
            </span>
          </div>
          <div className="reply-bottom">
            <div className="txt">{parse(data.data.comment)}</div>

            {data.data.images !== null && data.data.images.length !== 0 ? (
              <div style={{ width: "100%", paddingTop: "6px" }}>
                <img src={data.data.images} className="re-reply-img" />
              </div>
            ) : null}
            <div className="time">{data.data.created_at}</div>
          </div>
        </div>

        {data.data.comment_count > 1 ? (
          <div className="more-btn" onClick={checkPostState}>
            <Link
              to={
                isProfilePage
                  ? `/profile/${profilekey}/post/${props.idx}`
                  : `/page/${props.service_code}/${props.sectionTItle}/${props.idx}`
              }
            >
              查看更多评论
            </Link>
          </div>
        ) : null}
      </>
    ) : null
  ) : (
    <CommentsLoading />
  );
}

export default LastComment;
